import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BehaviorSubject, Subject } from 'rxjs';
import { ViewActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/view.component';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';

@Component({
  selector: 'app-compare-rates.component',
  templateUrl: './compare-rates.component.html',
  styleUrls: ['./compare-rates.component.scss']
})

export class compareRatesComponent {
  tatForm: FormGroup;
  @Input() public cellData: any = {};
  // @Input() public vendorOptions: any[];
  // @Input() public productOptions: any[];
  @Output() awbFormValues: any = new EventEmitter();
  isFormSubmitted = false;
  // awbNumber: string;
  selectedSCId: number;
  AWBTATList = [];

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;

  defaultColDef = {
    sortable: true,
    resizable: false,
    filter: true
  };

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight'
  }
  compareRatesRowData = [];
  columnDefs = [
    { headerName: 'Rates', field: 'rate', minWidth: 70, pinned: 'left' },
    { headerName: 'Other Charges', field: 'total_otherchargesamount', minWidth: 120, pinned: 'left' },
    { headerName: 'Fuel', field: 'total_fuel', minWidth: 70, pinned: 'left' },
    { headerName: 'Tax', field: 'taxamount', minWidth: 70, pinned: 'left' },
    { headerName: 'Grand Total', field: 'grandtotal', minWidth: 110, pinned: 'left' },
    { headerName: 'Weight', field: 'weight', minWidth: 90, pinned: 'left' },
    { headerName: 'Product', field: 'product', minWidth: 150 },
    { headerName: 'Vendor', field: 'vendor', minWidth: 150 },
    { headerName: 'Service', field: 'service', minWidth: 150 },
    { headerName: 'Origin Country', field: 'origincountry', minWidth: 150 },
    { headerName: 'Origin State', field: 'originstate', minWidth: 150 },
    { headerName: 'Origin City', field: 'origincity', minWidth: 150 },
    { headerName: 'Destination Country', field: 'destinationcountry', minWidth: 150 },
    { headerName: 'Destination State', field: 'destinationstate', minWidth: 150 },
    { headerName: 'Destination City', field: 'destinationcity', minWidth: 150 },
    { headerName: 'Zone', field: 'zone', minWidth: 100 },
    { 
      headerName: 'Action', 
      field: 'id', 
      cellRendererParams: { context: this }, 
      colId: 'params',
      minWidth: 80,
      cellRenderer: ViewActionsRenderer,
      editable: false,
      sortable: false,
      pinned: 'right'
    }
  ];

  constructor(
    private _fb: FormBuilder,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private awbService: AWBService,
    public activeModal: NgbActiveModal,
    private titleService: Title
  ) {
    titleService.setTitle('Air Way Bill');
    this.context = { componentParent: this, componentName: 'compareRatesComponent' }
  }

  ngOnInit() {
    this.tatForm = this._fb.group({
      txtDays: [null],
      txtHours: [null],
      txtMinutes: [null],
      txtRemark: [null, Validators.required]
    });

    if (this.cellData) {
      // this.getAllStatuses();
      // this.awbNumber = this.cellData.awbnumber;
      this.compareRatesRowData = this.cellData?.rates;
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  viewAction(data?: any) {
    this.awbFormValues.emit(data);
  }
}
